// CHECKPOINT: PRD-16 FR-16.6.3 Explicit subscriptions for body-free bulk notifications.
export const BULK_WEBHOOK_EVENTS = [
  { value: 'bulk.job.updated', label: 'Bulk job changes' },
  { value: 'bulk.recipient.accepted', label: 'Bulk recipient accepted' },
  { value: 'bulk.recipient.failed', label: 'Bulk recipient failed' },
  {
    value: 'bulk.recipient.submission_uncertain',
    label: 'Bulk uncertain submission',
  },
  {
    value: 'bulk.recipient.updated',
    label: 'Bulk recipient exclusions and cancellations',
  },
  { value: 'bulk.recipient.delivered', label: 'Bulk recipient delivered' },
  { value: 'bulk.recipient.bounced', label: 'Bulk recipient bounced' },
  { value: 'bulk.recipient.complained', label: 'Bulk recipient complaint' },
  { value: 'bulk.recipient.unsubscribed', label: 'Bulk marketing unsubscribe' },
  { value: 'bulk.access.updated', label: 'Bulk access changes' },
  { value: 'bulk.credits.low', label: 'Bulk low or exhausted credits' },
]
